document.addEventListener("DOMContentLoaded", function () {

    if (!document.querySelector(".blog-single")) {
        return;
    }
    const headerOffset = 150;

    const tocLinks = Array.from(document.querySelectorAll(".sticky-toc a"));
    if (tocLinks.length === 0) { return; }

    const sections = tocLinks
        .map(link => document.querySelector(link.getAttribute("href")))
        .filter(Boolean);

    // scroll-margin-top fallback
    sections.forEach(s => {
        if (!s.style.scrollMarginTop) { s.style.scrollMarginTop = headerOffset + 'px'; }
    });

    // Smooth scroll
    tocLinks.forEach(link => {
        link.addEventListener("click", function (e) {
            e.preventDefault();

            const target = document.querySelector(this.getAttribute("href"));
            if (!target) { return; }

            target.scrollIntoView({ behavior: "smooth", block: "start" });
            history.replaceState(null, '', this.getAttribute("href"));
        });
    });

    // Intersection Observer
    const observer = new IntersectionObserver((entries) => {
        const visibleEntries = entries.filter(e => e.isIntersecting);
        if (visibleEntries.length === 0) { return; }

        visibleEntries.sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        const topEntry = visibleEntries[0];
        if (!topEntry || !topEntry.target.id) { return; }

        const id = "#" + topEntry.target.id;

        tocLinks.forEach(link => {
            const li = link.closest("li");
            if (!li) { return; }
    
            li.classList.toggle("active", link.getAttribute("href") === id);
        });
    }, {
        threshold: [0.3],
        rootMargin: `-${headerOffset}px 0px -50% 0px`
    });

    sections.forEach(section => observer.observe(section));
});
